import useLocale from 'hooks/useLocale';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LastOrderDate.module.scss';

const categories = [
  'Cards',
  'Calendars',
  'Photo Books',
  'Canvas',
  'Posters',
  'Wall-Art',
  'Apparel',
  'Mugs',
  'Phone case',
];
const LAST_ORDER_DATE_SM_TAG = 'last-order-date-sm';
const LAST_ORDER_DATE_LG_TAG = 'last-order-date-lg';

export interface LastOrderDateProps {
  type: 'sm' | 'lg';
  theme: string;
  productId?: number;
  // Used for the LG version
  title?: string;
  description?: string;
  productHeader?: string;
  standardShippingHeader?: string;
  expressShippingHeader?: string;
  standardShippingHeaderShort?: string;
  expressShippingHeaderShort?: string;
}

const LastOrderDate: FC<LastOrderDateProps> = ({
  type = 'sm',
  theme,
  productId,
  title,
  description,
  productHeader,
  standardShippingHeader,
  expressShippingHeader,
  standardShippingHeaderShort,
  expressShippingHeaderShort,
}) => {
  const { t } = useTranslation();
  const locale = useLocale();

  const lastOrderDateSmProps = {
    title: t('txt_lod_product_page_title'),
    description: t('txt_lod_arrive_before'),
    'product-id': productId,
    'destination-country-iso-code': locale.substring(3),
    'shipping-method-header': t('txt_lod_shipping_method'),
    'order-by-header': t('txt_lod_order_by'),
    'express-shipping': t('txt_lod_express_shipping'),
    'standard-shipping': t('txt_lod_standard_shipping'),
    theme,
  };
  const lastOrderDateLgProps = {
    'destination-country-iso-code': locale.substring(3),
    locale,
    title,
    description,
    'product-header': productHeader,
    'standard-shipping-header': standardShippingHeader,
    'express-shipping-header': expressShippingHeader,
    'standard-shipping-header-short': standardShippingHeaderShort,
    'express-shipping-header-short': expressShippingHeaderShort,
    'category-uid': JSON.stringify(categories),
    theme,
  };

  return (
    <div>
      {type === 'sm' ? (
        <div className={styles.lastOrderDateSm}>
          {React.createElement(LAST_ORDER_DATE_SM_TAG, lastOrderDateSmProps, null)}
        </div>
      ) : (
        <div className={styles.lastOrderDateLg}>
          {React.createElement(LAST_ORDER_DATE_LG_TAG, lastOrderDateLgProps, null)}
        </div>
      )}
    </div>
  );
};

export default LastOrderDate;
